export default function composeReducers(reducers) {
  return function (state, action) {
    return reducers.reduceRight(function (prevState, reducer) {
      return reducer(prevState, action);
    }, state);
  };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-resource/es/utils/compose-reducers.js
// module id = 1029
// module chunks = 2